import { render, staticRenderFns } from "./cancelMark.vue?vue&type=template&id=0b4c5f1f&"
import script from "./cancelMark.vue?vue&type=script&lang=js&"
export * from "./cancelMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports